module.exports = __webpack_public_path__ + "static/img/case_9.e2f79b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_9.jpg
// module id = nJTI
// module chunks = 0